module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-transfer"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-5",
    staticStyle: {
      "min-height": "500px",
      "background-color": "white"
    }
  }, [_c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.heading[0]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lt), function(item, index) {
    return _c('tr', [_c('td', [_c('input', {
      staticClass: "check",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "change": function($event) {
          return _vm.tempPush(item)
        }
      }
    }), _c('span', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v(_vm._s(item[_vm.keys.label]))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.pushLeft
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.pushRight
    }
  }, [_vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5",
    staticStyle: {
      "min-height": "500px",
      "background-color": "white"
    }
  }, [_c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.heading[1]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.value), function(item, index) {
    return _c('tr', [_c('td', [_c('input', {
      staticClass: "check",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "change": function($event) {
          return _vm.tempPushl(item, index)
        }
      }
    }), _c('span', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v(_vm._s(item[_vm.keys.label]))])])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "el-icon-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfb80972"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transfer/transfer.vue
// module id = 847
// module chunks = 1